import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AccordionComponent implements OnInit, OnChanges {
  active: boolean = false;
  defaultCssStyles: object = {
    header: '',
    panel: '',
  };

  @Input() cssStyles: { header: string; panel: string } = { header: '', panel: '' };
  @Input() openOnIcon: boolean = false;
  @Input() manualOpen: boolean | undefined;
  @Input() isActiveOnStart: boolean = false;
  @Input() showIcon: boolean = false;
  @Input() equipmentSelection: boolean = false;
  @Output() panelOpened: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit(): void {
    this.active = this.manualOpen ?? this.isActiveOnStart;
    this.cssStyles = {...this.defaultCssStyles, ...this.cssStyles};
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.manualOpen && this.manualOpen !== undefined) {
      this.active = changes.manualOpen.currentValue;
    }
  }

  activePanel(): void {
    if (this.manualOpen !== undefined || this.openOnIcon) {
      return;
    }
    this.active = !this.active;
    if (this.active) {
      this.panelOpened.emit();
    }
  }

  activePanelOnIcon(): void {
    this.active = !this.active;
    this.panelOpened.emit();
  }
}
